import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import {ReviewerType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GRAY_DARKER, RED_DARK} from 'ui-library/Colors';
import {MinimalEntity} from 'ui-library/entity-input/EntityInputConstants';
import {EntityInputWithSearch} from 'ui-library/entity-input/EntityInputWithSearch';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';
import {assertNever} from 'util/Types';

import {searchForReviewers} from './ReviewUtil';

interface ReviewStageReviewerAssignmentRowProps {
  onChange: (user: MinimalEntity | null) => void;
  reviewerType: ReviewerType;
  authors: Array<MinimalEntity> | undefined;
  selectedUser: MinimalEntity | null;
  selectedTeamId: string | undefined;
  dataTestAttrs: DataTestAttrs;
  reviewSenderId: string | undefined;
  reviewableId: string;
}

export function ReviewStageReviewerAssignmentRow({
  onChange,
  reviewerType,
  authors,
  selectedUser,
  selectedTeamId,
  dataTestAttrs,
  reviewSenderId,
  reviewableId,
}: ReviewStageReviewerAssignmentRowProps): JSX.Element {
  let reviewerString = 'a reviewer';

  switch (reviewerType) {
    case ReviewerType.AUTHOR:
      reviewerString = 'an author';
      break;
    case ReviewerType.PROJECT_MEMBERS:
      reviewerString = 'a project collaborator';
      break;
    case ReviewerType.TEAM:
      reviewerString = 'a team member';
      break;
    default:
      assert(false, `Unexpected reviewerType: ${assertNever(reviewerType)}`);
  }

  return (
    <div {...getTestProps(dataTestAttrs)}>
      <EntityInputWithSearch
        search={(query: string) =>
          searchForReviewers(query, reviewerType, authors, selectedTeamId, reviewSenderId, reviewableId)
        }
        size={TagsInputSize.SMALL}
        onChange={(value: Array<MinimalEntity>) => {
          onChange(value[0] ?? null);
        }}
        searchAllResultsOnFocus={true}
        value={selectedUser ? [selectedUser] : []}
        enableNewEntityInput={true}
        shouldAllowMultiple={false}
        placeholder={`Search for ${reviewerString}`}
        emptyText="No matches found."
        emptyTextForAllResultsSearch={
          <div
            style={{display: 'flex', flexDirection: 'row'}}
            className={css(entityInputSearchStyles.emptyTextAllResults)}
          >
            <BenchlingIcon icon="revision" className={css(entityInputSearchStyles.icon)} />
            No reviewers available for this review stage.
          </div>
        }
        loadingText="Loading..."
      />
    </div>
  );
}
/** @package */
export const entityInputSearchStyles = StyleSheet.create({
  icon: {
    borderColor: RED_DARK,
    color: RED_DARK,
    marginRight: '4px',
    marginTop: '2px',
  },

  emptyTextAllResults: {
    color: GRAY_DARKER,
  },
});
